module.exports = __webpack_public_path__ + "img/囧.ec54d947.png";